export default {
  label: {
    en: 'Email address',
  },
  linkBack: {
    en: 'Back to login',
  },
  confirmMessage: {
    en: 'If your email exists in our database, you\'ll receive a reset link',
  },
  btnClose: {
    en: 'Close',
  },
}
